import { newId } from '../../utils/ids';

const DEVICE_ID_KEY = 'sync_device_id';

/**
 * Get or create a persistent device ID stored in localStorage.
 * This ID identifies the originating device for sync operations.
 */
export function getDeviceId(): string {
  let deviceId = localStorage.getItem(DEVICE_ID_KEY);
  if (!deviceId) {
    deviceId = newId();
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
  }
  return deviceId;
}

/**
 * Create sync metadata for a new record.
 */
export function createSyncMetadata(): {
  syncUpdatedAt: string;
  syncDeletedAt: undefined;
  syncDeviceId: string;
  syncVersion: number;
} {
  return {
    syncUpdatedAt: new Date().toISOString(),
    syncDeletedAt: undefined,
    syncDeviceId: getDeviceId(),
    syncVersion: 1,
  };
}

/**
 * Update sync metadata for an existing record.
 * Increments syncVersion and updates timestamp/device.
 */
export function updateSyncMetadata(existing: { syncVersion?: number }): {
  syncUpdatedAt: string;
  syncDeviceId: string;
  syncVersion: number;
} {
  return {
    syncUpdatedAt: new Date().toISOString(),
    syncDeviceId: getDeviceId(),
    syncVersion: (existing.syncVersion ?? 0) + 1,
  };
}

/**
 * Mark a record as soft-deleted.
 * Sets syncDeletedAt timestamp and increments version.
 */
export function softDeleteSyncMetadata(existing: { syncVersion?: number }): {
  syncUpdatedAt: string;
  syncDeletedAt: string;
  syncDeviceId: string;
  syncVersion: number;
} {
  return {
    syncUpdatedAt: new Date().toISOString(),
    syncDeletedAt: new Date().toISOString(),
    syncDeviceId: getDeviceId(),
    syncVersion: (existing.syncVersion ?? 0) + 1,
  };
}
